'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formActions = exports.removeItem = exports.addItem = exports.validate = exports.unset = exports.reset = exports.update = exports.load = exports.set = exports.submit = exports.REMOVE_ITEM = exports.ADD_ITEM = exports.VALIDATE = exports.UNSET = exports.RESET = exports.UPDATE = exports.SET = exports.SUBMIT = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUBMIT = exports.SUBMIT = 'abyss/form/SUBMIT';
var SET = exports.SET = 'abyss/form/SET';
var UPDATE = exports.UPDATE = 'abyss/form/UPDATE';
var RESET = exports.RESET = 'abyss/form/RESET';
var UNSET = exports.UNSET = 'abyss/form/UNSET';
var VALIDATE = exports.VALIDATE = 'abyss/form/VALIDATE';
var ADD_ITEM = exports.ADD_ITEM = 'abyss/form/ADD_ITEM';
var REMOVE_ITEM = exports.REMOVE_ITEM = 'abyss/form/REMOVE_ITEM';

var submit = exports.submit = function submit(model, onSuccess, onError) {
  return function (dispatch, getState) {
    var state = getState();
    var fields = utils.getFields(state, model);
    var invalidKey = Object.keys(fields).find(function (key) {
      return !fields[key].valid;
    });
    var modelValue = utils.mapFileUploads(utils.getModelValue(state, model));

    if (invalidKey) {
      setTimeout(function () {
        dispatch({
          type: SUBMIT,
          payload: {
            model: model,
            focus: fields[invalidKey].parent || invalidKey
          }
        });

        if (onError) {
          onError(modelValue, (0, _pickBy2.default)(fields, function (value) {
            return (0, _some2.default)(value.errors);
          }));
        }
      });
    } else {
      setTimeout(function () {
        dispatch({
          type: SUBMIT,
          payload: {
            model: model
          }
        });

        if (onSuccess) {
          onSuccess(modelValue, fields);
        }
      });
    }
  };
};

var set = exports.set = function set(model, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    type: SET,
    payload: {
      model: model,
      value: value,
      options: options
    }
  };
};

var load = exports.load = function load(model, value, options) {
  return function (dispatch, getState) {
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
      dispatch(set(model, value, options));
    } else {
      var isArray = Array.isArray(value);
      var currentValue = utils.getModelValue(getState(), model) || (isArray ? [] : {});
      var mergedValue = isArray ? currentValue.concat(value) : (0, _merge2.default)({}, currentValue, value);

      if (options || !(0, _isEqual2.default)(currentValue, mergedValue)) {
        dispatch(set(model, mergedValue, options));
      }
    }
  };
};

var update = exports.update = function update(model) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: UPDATE,
    payload: {
      model: model,
      options: options
    }
  };
};

var reset = exports.reset = function reset(model, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof window !== 'undefined') {
    window.__ABYSS_FORM_RESET__ = true;
    setTimeout(function () {
      return delete window.__ABYSS_FORM_RESET__;
    });
  }

  return {
    type: RESET,
    payload: {
      model: model,
      value: value,
      options: options
    }
  };
};

var unset = exports.unset = function unset(model) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: UNSET,
    payload: {
      model: model,
      options: options
    }
  };
};

var validate = exports.validate = function validate(model, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    type: VALIDATE,
    payload: {
      model: model,
      value: value,
      options: options
    }
  };
};

var addItem = exports.addItem = function addItem(model, value, index) {
  return {
    type: ADD_ITEM,
    payload: {
      model: model,
      value: value,
      index: index
    }
  };
};

var removeItem = exports.removeItem = function removeItem(model, index) {
  return {
    type: REMOVE_ITEM,
    payload: {
      model: model,
      index: index
    }
  };
};

var formActions = exports.formActions = {
  submit: submit,
  set: set,
  load: load,
  update: update,
  reset: reset,
  unset: unset,
  validate: validate,
  addItem: addItem,
  removeItem: removeItem
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/actions.js
// module id = 19
// module chunks = 0